export const PREMIUMINFO_REQUEST = 'PremiumInfoRequest';
export const PUBLICPREMIUMINFO_REQUEST = 'PublicPremiumInfoRequest';
export const PREMIUMINFO_FAILURE = 'PremiumInfoFailure';
export const PREMIUMINFO_SUCCESS = 'PremiumInfoSuccess';
export const PREMIUM_PRICING_TIERS_REQUEST = 'PremiumPricingTiersRequest';
export const PREMIUM_PRICING_TIERS_FAILURE = 'PremiumPricingTiersFailure';
export const PREMIUM_PRICING_TIERS_SUCCESS = 'PremiumPricingTiersSuccess';